/******************************************************************************************
 *	Mini JIL
 *******************************************************************************************
 *
 * Provides mock data replacing JIL for demo mode.
 *
 */
(function() {


  angular
    .module('rcServices.miniJil', [])
    .constant('CUSTOMER_SEGMENTS', {
      NO_PRODUCTS: 'no-products',
      PENDING_REQUESTS: 'pending-requests',
      PAST_DUE_REQUESTS: 'past-due-requests',
      UPCOMING_RENEWALS: 'upcoming-renewals',
      ALL: 'all',
      RENEWAL_WINDOW: 'renewal-window'
    })
    .service(
      'MiniJilStore',
      /* @ngInject */
      function(
        _,
        CUSTOMER_SEGMENTS,
        TEAM_MEMBER_SERVER_STATUS,
        PRODUCT_LICENSE_TYPES,
        THREE_YEAR_COMMIT_STATUSES,
        Utility,
        TeamMemberStatus,
        PaStatus,
        PLAN_TYPE,
        CustomerLoyaltyPrograms
      ) {
        /**************************************************
         *	In-memory Store
         **************************************************/
        var store = {
          demoUser: null,
          teamMembers: null,
          customerSegments: null,
          customerSegmentsMeta: null,
          customerSegmentsPagination: null,
          customers: null,
          offers: null,
          offersBySegment: null
        };

        /**************************************************
         *	Helpers
         **************************************************/

        //Generic-all-purpose ID generator
        //Acceps a stringLength argument which decided the length of the generated ID.
        //However, that's not entirely true:
        //while the generated string does have the specified length,
        //the output will get the currentId appended making it longer.
        //This is to make sure IDs are unique,
        var generateId = (function() {
          var currentId = -1;
          //Return generator function
          return function(stringLength) {
            currentId++;

            //The empty string makes sure it's concatenation and not addition
            return '' + Utility.getRandomString(stringLength) + currentId;
          };
        })();

        //AdobeID generator
        var generateAdobeId = function() {
          //AdobeIDs have 24 chars + "@AdobeID".
          return generateId(24) + '@AdobeID';
        };

        //Date offset parser
        //Some dates are specified as offsets (relative to `now`).
        //If an offset is present, parse it and return the corresponding date.
        //Offsets are easy to detect because they start with a `+` or `-` sign, whereas dates do not.
        var parseDateOffset = function(anniversaryDate) {
          //Pending customers don't have an anniversary date
          //Update the anniversary date only if it's an offset instead of a date.
          if (anniversaryDate && (anniversaryDate[0] === '+' || anniversaryDate[0] === '-')) {
            var offset = parseInt(anniversaryDate, 10);
            if (!offset || window.isNaN(offset)) {
              return anniversaryDate;
            }

            var date = new Date();
            date.setDate(date.getDate() + offset);

            return date.toISOString();
          }
          return anniversaryDate;
        };

        //Get team member by ID
        var getTeamMemberById = function(id) {
          for (var i = 0, count = store.teamMembers.length; i < count; i++) {
            if (store.teamMembers[i].userId === id) {
              return store.teamMembers[i];
            }
          }
          return null;
        };

        // Get team member by invitation code. Returns undefined if not found.
        var getTeamMemberByInvitationCode = function(invitationCode) {
          return store.teamMembers.find(function(element) {
            if (element.inviteCode === invitationCode) {
              return element;
            }
          });
        };

        //Changes a customer's RTM to the specified one
        var setCustomerRtm = function(customer, rtm) {
          customer.managedBy = {
            userId: rtm.userId,
            first_name: rtm.first_name,
            last_name: rtm.last_name,
            email: rtm.email
          };
        };

        //Replaces oldRtm with newRtm for all customers in store.customers
        var replaceRtm = function(oldRtm, newRtm) {
          //Updates customer's sales rep if the current RTM is oldRtm
          var updateSalesRep = function(customer) {
            if (customer.managedBy && customer.managedBy.userId === oldRtm.userId) {
              setCustomerRtm(customer, newRtm);
            }
          };

          //Iterate customers
          if (store.customers) {
            for (var customer in store.customers) {
              updateSalesRep(store.customers[customer].details);
            }
          }
        };

        //Remove passed in RTM from store
        //If the RTM is an active one, check if any
        //customers are managed by this RTM as to
        //assing them to the RA, the demoUser.
        var removeTeamMember = function(rtm) {
          //Need to know if RTM is active or not because inactive RTMs are removed by invitation code
          //whereas active ones are removed by user ID and also removed from customers.
          var isActive = TeamMemberStatus.isActive(rtm.status);

          for (var i = 0, count = store.teamMembers.length; i < count; i++) {
            //If either userId or inviteCode match, remove RTM from store
            if (
              (isActive && store.teamMembers[i].userId === rtm.userId) ||
              (!isActive && store.teamMembers[i].inviteCode === rtm.inviteCode)
            ) {
              //Remove RTM from store.teamMembers
              store.teamMembers.splice(i, 1);

              //Remove managedBy references from customers for active RTMs
              if (isActive) {
                replaceRtm(rtm, store.demoUser);
              }
              break;
            }
          }
        };

        //Get customer by ID - this is customer.details in payload
        var getCustomerById = function(id) {
          if (store.customers && store.customers[id]) {
            return store.customers[id];
          }
          return null;
        };

        // Get customer index in segment. Returns -1 if not found.
        var getCustomerIndexInSegment = function(customerId, segment) {
          if (store.customerSegments[segment]) {
            return _.findIndex(store.customerSegments[segment], ['id', customerId]);
          }

          return -1;
        };

        //Remove customer from segment
        var removeCustomerFromSegment = function(customerId, segment) {
          var index = getCustomerIndexInSegment(customerId, segment);

          if (index !== -1) {
            //Remove customer
            store.customerSegments[segment].splice(index, 1);
          }
        };

        //Move customer to segment, optionally removing him from previous segment.
        var moveCustomerToSegment = function(customer, segment, previousSegment) {
          //Make sure the segment exists
          if (!store.customerSegments[segment]) {
            store.customerSegments[segment] = [];
          }

          //Add the customer to the segment
          store.customerSegments[segment].push(customer);

          //Remove customer from previous segment
          if (customer && customer.id && previousSegment) {
            removeCustomerFromSegment(customer.id, previousSegment);
          }
        };

        //Change customer RTM
        var changeCustomerRtm = function(customerId, rtmId) {
          //Get RTM
          var rtm = getTeamMemberById(rtmId);
          if (!rtm) {
            return;
          }

          //Updates customer's sales rep
          var updateSalesRep = function(customer) {
            if (customer.id === customerId) {
              setCustomerRtm(customer, rtm);
            }
          };

          //Iterate customers
          if (store.customers) {
            for (var customer in store.customers) {
              updateSalesRep(store.customers[customer].details);
            }
          }
        };

        //Returns product details from the sellableItems object on a customer
        var getProductDetails = function(customerId, activeSellableSku) {
          if (
            store.customers[customerId]
          ) {
            var products = store.customers[customerId].products.productList;
            var totalProducts = products.length;
            for (var i = 0; i < totalProducts; i++) {
              if (products[i].activeSellableSku === activeSellableSku) {
                return products[i];
              }
            }
          }

          //Fallback to fictive product code and name
          return {
            activeSellableSku: activeSellableSku,
            productCode: 'UNKN',
            productName: 'Unknown'
          };
        };

        //Returns offer details from the offers for a customer
        var getOfferDetails = function(customerId, offer_id) {
          var segment = _.get(store, 'customers[' + customerId + '].details.marketSegment');
          var offersForSegment = _.get(store, 'offersBySegment.marketSegments[' + segment + ']');
          var foundOffer = _.find(offersForSegment, {offer_id: offer_id});
          if (foundOffer) {
            return foundOffer;
          }

          //Fallback to fictive product code and name
          return {
            offer_id: offer_id,
            product_arrangement_code: 'unkn_indirect_team',
            product_code: 'UNKN',
            merchandising: {
              copy: {
                short_name: 'Unknown'
              }
            }
          };
        };

        /**************************************************
         *	Public interface
         **************************************************/

        /*=== Demo User ===*/
        Object.defineProperty(this, 'demoUser', {
          set: function(data) {
            store.demoUser = data;

            //Add first_name and last_name in addition to firstName and lastName
            //for consistency with format of RTMs
            store.demoUser.first_name = store.demoUser.firstName;
            store.demoUser.last_name = store.demoUser.lastName;
          },
          get: function() {
            return store.demoUser;
          }
        });

        /*=== Offers ===*/
        Object.defineProperty(this, 'offers', {
          set: function(data) {
            store.offers = data;
          },
          get: function() {
            return store.offers;
          }
        });

        /*=== Offers ===*/
        Object.defineProperty(this, 'offersBySegment', {
          set: function(data) {
            store.offersBySegment = data;
          },
          get: function() {
            return store.offersBySegment;
          }
        });

        /*=== Reseller Team Members ===*/
        Object.defineProperty(this, 'teamMembers', {
          set: function(data) {
            store.teamMembers = data;
          },
          get: function() {
            return store.teamMembers;
          }
        });
        Object.defineProperty(this, 'activeTeamMembers', {
          get: function() {
            if (!store.teamMembers) {
              return null;
            }

            return _.filter(store.teamMembers, function(item) {
              return TeamMemberStatus.isActive(item.status);
            });
          }
        });

        //Create and return a new team member object from a string email address
        this.addTeamMember = function(email) {
          //Create team member
          var newTeamMember = {
            canBeDeleted: true,
            email: email,
            status: _.toUpper(TEAM_MEMBER_SERVER_STATUS.PENDING),
            userId: generateAdobeId(),
            inviteCode: generateId(20),
            first_name: null,
            last_name: null,
            resellerOrg: null
          };

          //Add to store
          if (!store.teamMembers) {
            store.teamMembers = [];
          }
          store.teamMembers.push(newTeamMember);

          return newTeamMember;
        };

        //Remove team member by ID and return boolean success status
        this.removeTeamMember = function(teamMemberId) {
          var rtm = getTeamMemberById(teamMemberId);
          if (rtm) {
            removeTeamMember(rtm);
            return true;
          }

          return false;
        };

        //Remove team member by ID and return boolean success status
        this.cancelTeamMemberInvitation = function(invitationCode) {
          var rtm = getTeamMemberByInvitationCode(invitationCode);
          if (rtm) {
            removeTeamMember(rtm);
            return true;
          }

          return false;
        };

        // Go through customers of each segment and replace each customer with pointer to the same
        // information which is stored in the details for the customer in store.customers.
        // The implication of this is that customer details data only needs to be updated once from
        // either store.customerSegments or store.customers.
        var fixupSegments = function() {
          // Fixup the customer at index within the segment.
          var fixupCustomer = function(customer, index, segment) {
            var customerDetails = getCustomerById(customer.id);
            if (customerDetails) {
              segment[index] = customerDetails.details;
            }
          };

          // Loop thru segments fixing up the customers in each segment.
          for (var segment in store.customerSegments) {
            var customersInSegment = store.customerSegments[segment];
            _.forEach(customersInSegment, fixupCustomer);
          }
        };

        // Rather than attempting date math, for demo purposes it is easier just to replace
        // the year since it comes first in an ISO date string.
        var generateLoyalty3YCEndDates = function(endDate) {
          var plusOne = String(+endDate.slice(0, 4) + 1) + endDate.slice(4);
          var plusTwo = String(+endDate.slice(0, 4) + 2) + endDate.slice(4);

          return [endDate, plusOne, plusTwo];
        };

        /*=== Customer Segments ===*/
        Object.defineProperty(this, 'customerSegments', {
          set: function(data) {
            store.customerSegments = data;
            if (store.customers) {
              fixupSegments();
            }
          },
          get: function() {
            return store.customerSegments;
          }
        });
        Object.defineProperty(this, 'customerSegmentsMeta', {
          set: function(data) {
            store.customerSegmentsMeta = data;
          },
          get: function() {
            return store.customerSegmentsMeta;
          }
        });
        Object.defineProperty(this, 'customerSegmentsPagination', {
          set: function(data) {
            store.customerSegmentsPagination = data;
          },
          get: function() {
            return store.customerSegmentsPagination;
          }
        });

        /*=== Customer Details ===*/
        Object.defineProperty(this, 'customers', {
          set: function(data) {
            store.customers = data;

            //Parse any dates that could be offset values for all customers
            if (store.customers) {
              var parseDatesInPurchases = function(item) {
                item.authorizationDate = parseDateOffset(item.authorizationDate);
                item.statusDate = parseDateOffset(item.statusDate);
              };
              var parseDatesInRenewals = function(item) {
                item.orderDate = parseDateOffset(item.orderDate);
              };
              var parseDatesInLoyaltyFeatures = function(item) {
                if (item.hasOwnProperty('startDate')) {
                  item.startDate = parseDateOffset(item.startDate);
                }
                if (item.hasOwnProperty('endDate')) {
                  item.endDate = parseDateOffset(item.endDate);

                  if (item.hasOwnProperty('name') && item.name === 'THREE_YEAR_COMMIT') {
                    if (
                      item.hasOwnProperty('status') &&
                      item.status === THREE_YEAR_COMMIT_STATUSES.ENROLLED
                    ) {
                      item.endDates = generateLoyalty3YCEndDates(item.endDate);
                    }
                  }
                }
              };
              var parseDatesInLoyaltyInfo = function(loyaltyItem) {
                if (loyaltyItem.features && loyaltyItem.features.length) {
                  _.forEach(loyaltyItem.features, parseDatesInLoyaltyFeatures);
                }
              };

              for (var customerId in store.customers) {
                var customer = store.customers[customerId];

                if (customer.details) {
                  customer.details.anniversaryDate = parseDateOffset(
                    customer.details.anniversaryDate
                  );

                  //Renewal Window start and end date
                  if (customer.details.renewalWindowInfo) {
                    if (customer.details.renewalWindowInfo.startDate) {
                      customer.details.renewalWindowInfo.startDate = parseDateOffset(
                        customer.details.renewalWindowInfo.startDate
                      );
                    }
                    if (customer.details.renewalWindowInfo.endDate) {
                      customer.details.renewalWindowInfo.endDate = parseDateOffset(
                        customer.details.renewalWindowInfo.endDate
                      );
                    }
                  }
                }
                if (customer.purchases && customer.purchases.length) {
                  _.forEach(customer.purchases, parseDatesInPurchases);
                }
                if (customer.renewals && customer.renewals.length) {
                  _.forEach(customer.renewals, parseDatesInRenewals);
                }
                if (customer.loyaltyInfo && customer.loyaltyInfo.length) {
                  _.forEach(customer.loyaltyInfo, parseDatesInLoyaltyInfo);
                }

                // If the customer doesn't have a cleansedAddress defined, add it in
                if (!customer.details.cleansedAddress) {
                  customer.details.cleansedAddress = angular.copy(customer.details.address);
                }
              }

              if (store.customerSegments) {
                fixupSegments();
              }
            }
          },
          get: function() {
            return store.customers;
          }
        });

        var parseDatesInUsage = function(item) {
          item.expirationDate = parseDateOffset(item.expirationDate);
          item.startDate = parseDateOffset(item.startDate);
        };

        /*=== Consumables ===*/
        Object.defineProperty(this, 'consumables', {
          set: function(data) {
            store.consumables = data;

            //Parse any dates that could be offset values for all consumables
            if (store.consumables) {
              _.forEach(store.consumables, summarizationList => {
                _.forEach(summarizationList, summarization => {
                  _.forEach(summarization.summaries, summary => {
                    _.forEach(summary.consumables, consumable => {
                      // eslint-disable-next-line max-nested-callbacks
                      _.forEach(consumable.usages, usage => {
                        parseDatesInUsage(usage);
                      });
                    });
                  });
                });
              });
            }
          },
          get: function() {
            return store.consumables;
          }
        });

        /*=== Usage ===*/
        Object.defineProperty(this, 'usage', {
          set: function(data) {
            store.usage = data;

            //Parse any dates that could be offset values for all consumables
            if (store.usage) {
              _.forEach(store.usage, orgFIcodes => {
                _.forEach(orgFIcodes, fiUsageList => {
                  _.forEach(fiUsageList, usage => {
                    parseDatesInUsage(usage);
                  });
                });
              });
            }
          },
          get: function() {
            return store.usage;
          }
        });

        // Return true, if every type in the filter, is also in the customer's normalizedPlanTypes.
        var isInPlanTypeFilter = function(normalizedPlanTypes, filterPlanTypes) {
          normalizedPlanTypes = normalizedPlanTypes || [];
          filterPlanTypes = filterPlanTypes || [];

          for (var i = 0; i < filterPlanTypes.length; i++) {
            if (!_.includes(normalizedPlanTypes, filterPlanTypes[i])) {
              return false;
            }
          }

          return true;
        };

        /*=== Get Customers, with support for filters Managed By Me and Plan Type ===*/
        this.getCustomers = function(requestedSegment, payload) {
          var filterPlanTypes = payload.normalizedPlanTypes;
          var filterById = payload.ownerId;

          var visibleCustomers = [];
          var segmentMeta = angular.copy(store.customerSegmentsMeta);

          // Loop thru the customer segment metadata.
          // Calculate the count of visibleCustomers in each segment accounting for any requested filters.
          // For the requested segment, also build the list of visibleCustomers.
          _.forEach(segmentMeta, function(segment) {
            segment.count = 0;

            var customersInSegment = store.customerSegments[segment.path];
            if (customersInSegment) {
              _.forEach(customersInSegment, function(customer) {
                if (
                  !filterById ||
                  (customer.managedBy && customer.managedBy.userId === filterById)
                ) {
                  if (
                    !filterPlanTypes ||
                    isInPlanTypeFilter(customer.normalizedPlanTypes, filterPlanTypes)
                  ) {
                    segment.count++;
                    if (segment.path === requestedSegment) {
                      visibleCustomers.push(customer);
                    }
                  }
                }
              });
            }
          });

          return {
            meta: segmentMeta,
            customers: visibleCustomers,
            pagination: store.customerSegmentsPagination
          };
        };
        /*=== Invite Customer ===*/
        this.inviteCustomer = function(customer) {
          //Add missing data to form object
          customer.id = generateAdobeId();
          customer.active = false;
          customer.lastInviteDate = new Date().toISOString();
          customer.admin.userId = generateAdobeId();
          customer.managedBy = {
            email: store.demoUser.email,
            userId: store.demoUser.userId,
            first_name: store.demoUser.firstName,
            last_name: store.demoUser.lastName
          };
          customer.normalizedPlanTypes = [customer.requestedPlanType];

          customer.delegationSummary = {
            totalSummary: {
              activeSeatCount: 0,
              availableSeatCount: 0,
              overActivatedSeatCount: 0,
              paidSeatCount: 0,
              totalSeatCount: 0,
              unpaidSeatCount: 0
            }
          };
          customer.oneConsoleMigrationStatus = 'MIGRATED';
          customer.canCreatePA = true;
          // Save the new customer.
          store.customers[customer.id] = {details: customer};
          // Add new customer to No Products and All segments
          moveCustomerToSegment(customer, CUSTOMER_SEGMENTS.NO_PRODUCTS);
          moveCustomerToSegment(customer, CUSTOMER_SEGMENTS.ALL);

          return customer;
        };

        /*=== Cancel Customer Invitation ===*/
        // Cancel invitation for a customer, which is basically removing them from the no-products and all customer segments
        this.cancelCustomerInvitation = function(customerId) {
          removeCustomerFromSegment(customerId, CUSTOMER_SEGMENTS.NO_PRODUCTS);
          removeCustomerFromSegment(customerId, CUSTOMER_SEGMENTS.ALL);
        };

        this.updateCustomerInvitation = function(customerId, payload) {
          // update email and last invite date on the customer
          const customer = getCustomerById(customerId);
          const lastInviteSentString = new Date().toISOString();
          _.set(customer, 'details.admin.email', payload.email);
          _.set(customer, 'details.lastInviteDate', lastInviteSentString);
          const returnValue = _.assign({}, payload);
          returnValue.lastInviteDate = lastInviteSentString;
          return returnValue;
        };

        /*=== New Purchase Authorization ===*/
        //Creating a PA is a rather complex operation.
        //When you create a PA, you also:
        // - create or update an entry in the Products array
        // - create an entry in the PA history array
        // - add customer to `Pending Requests` if not already in it,
        //   without removing the customer from other segments (exception for `No Products` customers)
        // - move a `No Products` customer to `Pending Requests` segment
        // - update seat counts for a customer already in `Pending Requests` segment
        this.newPurchaseAuthorization = function(customerId, purchaseDetails) {
          //Customer details for customerId
          var customerDetails = store.customers[customerId];

          //Calculate purchase duration
          var purchaseDuration = 12; //Default value in case everything fails
          if (getCustomerIndexInSegment(customerId, CUSTOMER_SEGMENTS.RENEWAL_WINDOW) !== -1) {
            purchaseDuration = 12;
          } else if (customerDetails.details.anniversaryDate) {
            //Compute distance in months between now and anniversary date
            var anniversaryDate = new Date(customerDetails.details.anniversaryDate);
            if (!Utility.isValidDate(anniversaryDate)) {
              purchaseDuration = Utility.getMonthsBetween(new Date(), anniversaryDate);
            }
          }

          var newPurchase;

          //Products in purchaseDetails will be iterated over and the ones
          //that are new (i.e. are not present in customer.products array)
          //will be saved in newProducts array
          var newProducts = [];
          var totalSeatsPurchased = 0;

          //Reference to the list of products
          var currentProducts = null;
          if (store.customers[customerId].products) {
            currentProducts = store.customers[customerId].products.productList;
          }

          // See if we should use offers and cart-formatted data
          if (
            purchaseDetails &&
            !purchaseDetails.purchaseItems &&
            purchaseDetails.billing_summary
          ) {
            //Compute the total number of seats purchased
            if (purchaseDetails && purchaseDetails.billing_summary.billable_items) {
              totalSeatsPurchased = _.reduce(
                purchaseDetails.billing_summary.billable_items,
                function(total, item) {
                  return total + item.quantity;
                },
                0
              );
            }

            //Purchase object to be added to the customer.purchases array
            newPurchase = {
              id: generateId(20), //Purchase ID, not Offering ID, unlike customers.products
              authorizationDate: new Date().toISOString(),
              authorizationDurationMonths: purchaseDuration,
              authorizedByType: null,
              authorizedBy: {
                email: store.demoUser.email,
                userId: store.demoUser.userId,
                first_name: store.demoUser.firstName,
                last_name: store.demoUser.lastName
              },
              canBeDeleted: true,
              entitledPlanType: [], // will be updated based on offers chosen
              offeringCode: 'CCLE-COMPLETE-OFFERING',
              //PO Number is optional, generate value if none was passed in
              poNumber: purchaseDetails.billing_summary.customer_po_number || generateId(20),
              seatCount: totalSeatsPurchased,
              status: PaStatus.getPendingStatusId(),
              purchaseItems: [] //Populated below
            };

            var teamPurchaseCount = 0;
            var evipPurchaseCount = 0;

            //Go over purchased products and update the customer's products and purchases
            if (purchaseDetails && purchaseDetails.billing_summary.billable_items) {
              _.forEach(purchaseDetails.billing_summary.billable_items, function(item) {
                //Get product details.
                //Products in billing_summary.billable_items only contain the offer ID. No name or code.
                var productDetails = getOfferDetails(customerId, item.offer_id);

                if (productDetails.customer_segment === 'ENTERPRISE') {
                  evipPurchaseCount++;
                } else {
                  teamPurchaseCount++;
                }

                //Purchases data
                newPurchase.purchaseItems.push({
                  quantity: item.quantity,
                  unpaidQuantity: item.quantity,
                  productInfo: {
                    offer_id: item.offer_id,
                    productCode: productDetails.product_code,
                    productName: productDetails.merchandising.copy.short_name,
                    licenseType: PRODUCT_LICENSE_TYPES.USER
                  }
                });

                //Products data
                //Check if the current product already exists in the customer's list of products.
                //If it does, update the unpaidSeatCount property.
                //Otherwise, add it to the newProducts array which will be concatenated to customer's array of products.
                var existingProduct = false;
                if (currentProducts && currentProducts.length) {
                  for (var i = 0, count = currentProducts.length; i < count; i++) {
                    if (currentProducts[i].productInfo.offer_id === item.offer_id) {
                      currentProducts[i].unpaidSeatCount += item.quantity;
                      existingProduct = true;
                      break;
                    }
                  }
                }

                //Product does not exist in the customer's list of products.
                //Save it in the newProducts array.
                if (!existingProduct) {
                  newProducts.push({
                    paidSeatCount: 0,
                    unpaidSeatCount: item.quantity,
                    productInfo: {
                      offer_id: item.offer_id,
                      productCode: productDetails.product_code,
                      productName: productDetails.merchandising.copy.short_name,
                      licenseType: PRODUCT_LICENSE_TYPES.USER,
                      language: 'MUN'
                    }
                  });
                }
              });
            }
            if (evipPurchaseCount > 0) {
              newPurchase.entitledPlanType.push(PLAN_TYPE.ENTERPRISE);
            }
            if (teamPurchaseCount > 0) {
              newPurchase.entitledPlanType.push(PLAN_TYPE.TEAM);
            }
          } else {
            //Compute the total number of seats purchased
            if (purchaseDetails && purchaseDetails.purchaseItems) {
              totalSeatsPurchased = _.reduce(
                purchaseDetails.purchaseItems,
                function(total, item) {
                  return total + item.quantity;
                },
                0
              );
            }

            //Purchase object to be added to the customer.purchases array
            newPurchase = {
              id: generateId(20), //Purchase ID, not Offering ID, unlike customers.products
              authorizationDate: new Date().toISOString(),
              authorizationDurationMonths: purchaseDuration,
              authorizedByType: null,
              authorizedBy: {
                email: store.demoUser.email,
                userId: store.demoUser.userId,
                first_name: store.demoUser.firstName,
                last_name: store.demoUser.lastName
              },
              canBeDeleted: true,
              entitledPlanType: [PLAN_TYPE.TEAM],
              offeringCode: 'CCLE-COMPLETE-OFFERING',
              //PO Number is optional, generate value if none was passed in
              poNumber: purchaseDetails.poNumber || generateId(20),
              seatCount: totalSeatsPurchased,
              status: PaStatus.getPendingStatusId(),
              purchaseItems: [] //Populated below
            };

            //Go over purchased products and update the customer's products and purchases
            if (purchaseDetails && purchaseDetails.purchaseItems) {
              _.forEach(purchaseDetails.purchaseItems, function(item) {
                //Get product details.
                //Products in purchaseDetails.purchaseItems only contain the product ID. No name or code.
                var productDetails = getProductDetails(
                  customerId,
                  item.productInfo.activeSellableSku
                );

                //Purchases data
                newPurchase.purchaseItems.push({
                  quantity: item.quantity,
                  unpaidQuantity: item.quantity,
                  productInfo: {
                    activeSellableSku: item.productInfo.activeSellableSku,
                    productCode: productDetails.productCode,
                    productName: productDetails.productName,
                    licenseType: PRODUCT_LICENSE_TYPES.USER
                  }
                });

                //Products data
                //Check if the current product already exists in the customer's list of products.
                //If it does, update the unpaidSeatCount property.
                //Otherwise, add it to the newProducts array which will be concatenated to customer's array of products.
                var existingProduct = false;
                if (currentProducts && currentProducts.length) {
                  for (var i = 0, count = currentProducts.length; i < count; i++) {
                    if (
                      currentProducts[i].productInfo.activeSellableSku ===
                      item.productInfo.activeSellableSku
                    ) {
                      currentProducts[i].unpaidSeatCount += item.quantity;
                      existingProduct = true;
                      break;
                    }
                  }
                }

                //Product does not exist in the customer's list of products.
                //Save it in the newProducts array.
                if (!existingProduct) {
                  newProducts.push({
                    paidSeatCount: 0,
                    unpaidSeatCount: item.quantity,
                    productInfo: {
                      activeSellableSku: item.productInfo.activeSellableSku,
                      productCode: productDetails.productCode,
                      productName: productDetails.productName,
                      licenseType: PRODUCT_LICENSE_TYPES.USER,
                      language: 'MUN'
                    }
                  });
                }
              });
            }
          }

          //If the customer previously had no products or purchases, these need to be de-null-ified™.
          if (!store.customers[customerId].products) {
            store.customers[customerId].products = {
              id: '0123456789', //Ofering ID isn't used for anything, adding it for consistency
              offeringCode: 'CCLE-COMPLETE-OFFERING',
              productList: []
            };
          }
          if (!store.customers[customerId].purchases) {
            store.customers[customerId].purchases = [];
          }

          //Save new info to customer store
          if (newPurchase.entitledPlanType[0] === PLAN_TYPE.TEAM) {
            store.customers[customerId].products.productList = store.customers[
              customerId
            ].products.productList.concat(newProducts);
          } else if (newPurchase.entitledPlanType[0] === PLAN_TYPE.ENTERPRISE) {
            if (!store.customers[customerId].EVIPProducts) {
              store.customers[customerId].EVIPProducts = {
                delegationSummary: {namedSummary: {}},
                productList: []
              };
            }
            store.customers[customerId].EVIPProducts.productList = store.customers[
              customerId
            ].EVIPProducts.productList.concat(newProducts);
          }
          store.customers[customerId].purchases.push(newPurchase);

          //Check if and how this new purchase affects the customer's segment "membership".
          //First, check if the customer is in `Pending Requests`.
          //If true, update pendingRequest object.
          //If false, create the pendingRequest object on the customer and
          //add the customer to `Pending Requests` segment or move him entirely
          //if the customer previously had no products.
          //Note pendingRequest is being updated via the segment, and not in customer detail but both are the same object.
          var pendingRequestsIndex = getCustomerIndexInSegment(
            customerId,
            CUSTOMER_SEGMENTS.PENDING_REQUESTS
          );
          if (pendingRequestsIndex !== -1) {
            //Customer is in `Pending Requests`
            //Update seatCount. daysCount stays untouched.
            store.customerSegments[CUSTOMER_SEGMENTS.PENDING_REQUESTS][
              pendingRequestsIndex
            ].pendingRequest.seatCount += totalSeatsPurchased;
          } else {
            //Customer is not in `Pending Requests`
            //Get the customer to be added to `Pending Requests`.
            //In the context of segments, a "customer" refers to the customer.details object from customer details array (i.e. without purchases, products etc)
            var customer = customerDetails.details;

            //Customers outside `Pending Requests` segment don't have a pendingRequest object.
            customer.pendingRequest = {
              daysCount: 30, //Customers start off with 30 days in which to make the payment
              seatCount: totalSeatsPurchased //First purchase, so total seat count is the total purchased just now
            };

            _.forEach(newPurchase.entitledPlanType, function(item) {
              if (!_.includes(customer.normalizedPlanTypes)) {
                customer.normalizedPlanTypes.push(item);
              }
            });

            var noProductsIndex = getCustomerIndexInSegment(
              customerId,
              CUSTOMER_SEGMENTS.NO_PRODUCTS
            );
            if (noProductsIndex !== -1) {
              //Customer in `No Products`
              moveCustomerToSegment(
                customer,
                CUSTOMER_SEGMENTS.PENDING_REQUESTS,
                CUSTOMER_SEGMENTS.NO_PRODUCTS
              );
            } else {
              //Customer not in `No Products` or `Pending Requests`
              moveCustomerToSegment(customer, CUSTOMER_SEGMENTS.PENDING_REQUESTS);
            }
          }
        };

        /*=== Update customer ===*/
        // Possible payloads are:
        //   managedBy
        //   customer which has the structure of one of the store.customer's detail object
        this.updateCustomer = function(customerId, payload) {
          //Update sales rep
          if (payload.managedBy && payload.managedBy.userId) {
            changeCustomerRtm(customerId, payload.managedBy.userId);
            return getCustomerById(customerId);
          }

          // Edit customer info.
          if (!payload.active && payload.address && payload.admin) {
            // Update customer in customers object.
            var customer = getCustomerById(customerId);
            if (customer) {
              _.assign(customer.details, payload);
            }

            return customer;
          }

          // For any case that isn't handled.
          return getCustomerById(customerId);
        };

        /*=== Remove Purchase Authorization ===*/
        //If creating a PA is complex, so is removing one.
        //When you remove a PA, you also:
        // - set PA status as "Removed"
        // - update Products object
        // - remove customer from `Pending Requests` if no other pending PAs exist or
        //   update seat counts if other pending PAs exist
        // - move customer to `No Products` if the customer no longer has any products
        this.removePurchaseAuthorization = function(customerId, purchaseId) {
          //Customer details for customerId
          var customerDetails = store.customers[customerId];

          //Find details of purchase to be removed and update its status
          var removedPurchaseDetails;
          if (customerDetails && customerDetails.purchases) {
            for (var i = 0, count = customerDetails.purchases.length; i < count; i++) {
              if (customerDetails.purchases[i].id === purchaseId) {
                //Save purchase details
                removedPurchaseDetails = customerDetails.purchases[i];

                //Set PA status to "Removed" and prevent it from being deleted again
                removedPurchaseDetails.canBeDeleted = false;
                removedPurchaseDetails.status = PaStatus.getRemovedStatusId();

                break;
              }
            }
          }

          //Deal with side-effects of removing a PA
          if (removedPurchaseDetails) {
            //Update customer products and segment seat count or remove them entirely
            if (removedPurchaseDetails.purchaseItems) {
              var products = customerDetails.products;
              var evipProducts = customerDetails.EVIPProducts;
              _.forEach(removedPurchaseDetails.purchaseItems, function(removedPurchase) {
                //Update customer products count or remove the product entirely if the count is 0 or less
                products.productList = _.filter(products.productList, function(purchase) {
                  if (
                    purchase.product.activeSellableSku ===
                      removedPurchase.product.activeSellableSku ||
                    purchase.product.offerId === removedPurchase.product.offerId
                  ) {
                    //Update unpaid seat count
                    purchase.unpaidSeatCount -= removedPurchase.quantity;

                    //Only keep products which have an unpaid or paid seat count greater than 0
                    return purchase.unpaidSeatCount > 0 || purchase.paidSeatCount > 0;
                  }
                  return true;
                });
                //Update customer evipProducts count or remove the product entirely if the count is 0 or less
                if (evipProducts && evipProducts.productList) {
                  evipProducts.productList = _.filter(evipProducts.productList, function(purchase) {
                    if (purchase.product.offerId === removedPurchase.product.offerId) {
                      //Update unpaid seat count
                      purchase.unpaidSeatCount -= removedPurchase.quantity;

                      //Only keep products which have an unpaid or paid seat count greater than 0
                      return purchase.unpaidSeatCount > 0 || purchase.paidSeatCount > 0;
                    }
                    return true;
                  });
                }

                //Check if there are any products left after removing products from the remove PA
                //If there aren't, set the products object to null as it would be if sent from JIL
                if (products.productList.length === 0) {
                  customerDetails.products = null;
                }

                //Update customer pastDueRequest.seats count or remove customer from that segment entirely if 0 ore less
                //Note pendingRequest is being updated via the segment, and not in customer detail but both are the same object.
                var pendingRequestsIndex = getCustomerIndexInSegment(
                  customerId,
                  CUSTOMER_SEGMENTS.PENDING_REQUESTS
                );
                if (pendingRequestsIndex !== -1) {
                  //Customer is in `Pending Requests`
                  //Update seatCount
                  store.customerSegments[CUSTOMER_SEGMENTS.PENDING_REQUESTS][
                    pendingRequestsIndex
                  ].pendingRequest.seatCount -= removedPurchase.quantity;

                  //Update daysCount
                  //To get the days count, you need to iterate all pending purchases,
                  //find the earliest purchase and compute the number of days between it and today.
                  if (customerDetails.purchases) {
                    var earliestPendingPurchaseDate;
                    for (var i = 0, count = customerDetails.purchases.length; i < count; i++) {
                      var purchase = customerDetails.purchases[i];
                      if (PaStatus.isPending(purchase.status)) {
                        if (
                          !earliestPendingPurchaseDate ||
                          earliestPendingPurchaseDate > purchase.authorizationDate
                        ) {
                          earliestPendingPurchaseDate = purchase.authorizationDate;
                        }
                      }
                    }

                    earliestPendingPurchaseDate = new Date(earliestPendingPurchaseDate);
                    if (Utility.isValidDate(earliestPendingPurchaseDate)) {
                      var now = new Date();
                      var dayCount = 30 - Utility.getDaysBetween(earliestPendingPurchaseDate, now);
                      if (dayCount <= 0) {
                        dayCount = 30; //Fallback, should never be 0 or less
                      }

                      store.customerSegments[CUSTOMER_SEGMENTS.PENDING_REQUESTS][
                        pendingRequestsIndex
                      ].pendingRequest.daysCount = dayCount;
                    }
                  }

                  //If seatCount is 0 or less, remove customer from `Pending Requests` segment
                  if (
                    store.customerSegments[CUSTOMER_SEGMENTS.PENDING_REQUESTS][pendingRequestsIndex]
                      .pendingRequest.seatCount <= 0
                  ) {
                    //In the context of segments, a "customer" refers to the customer.details object from customer details array (i.e. without purchases, products etc)
                    var customer = customerDetails.details;
                    customer.normalizedPlanTypes = [];
                    if (
                      customerDetails.products &&
                      customerDetails.products.productList &&
                      customerDetails.products.productList.length > 0
                    ) {
                      customer.normalizedPlanTypes.push(PLAN_TYPE.TEAM);
                    }
                    if (
                      customerDetails.EVIPProducts &&
                      customerDetails.EVIPProducts.productList &&
                      customerDetails.EVIPProducts.productList.length > 0
                    ) {
                      customer.normalizedPlanTypes.push(PLAN_TYPE.ENTERPRISE);
                    }

                    //If the customer doesn't have any more products, move to `No Products` segment
                    if (!customerDetails.products) {
                      moveCustomerToSegment(
                        customer,
                        CUSTOMER_SEGMENTS.NO_PRODUCTS,
                        CUSTOMER_SEGMENTS.PENDING_REQUESTS
                      );
                    } else {
                      //Otherwise, remove him from `Pending Requests`
                      removeCustomerFromSegment(customer.id, CUSTOMER_SEGMENTS.PENDING_REQUESTS);
                    }
                  }
                }
              });
            }
          }
        };

        this.get3YCLoyaltyInfo = function(customerId) {
          var customer = this.customers[customerId];

          var loyaltyPrograms = new CustomerLoyaltyPrograms(customer.loyaltyInfo);
          var selectLoyaltyProgram = loyaltyPrograms[CustomerLoyaltyPrograms.SELECT];
          return selectLoyaltyProgram.hasThreeYearCommit()
            ? {
                endDate: selectLoyaltyProgram.features.THREE_YEAR_COMMIT.endDate,
                endDates: selectLoyaltyProgram.features.THREE_YEAR_COMMIT.endDates
              }
            : null;
        };

        this.update3YCLoyaltyInfo = function(customerId, endDate) {
          var customer = this.customers[customerId];

          var loyaltyPrograms = new CustomerLoyaltyPrograms(customer.loyaltyInfo);
          var selectLoyaltyProgram = loyaltyPrograms[CustomerLoyaltyPrograms.SELECT];
          if (selectLoyaltyProgram.hasThreeYearCommit()) {
            selectLoyaltyProgram.features.THREE_YEAR_COMMIT.endDate = endDate;

            // Generate new end dates based on the current end date. Not sure if this is the way
            // the API actually works but it will allow us to test end date changes.
            selectLoyaltyProgram.features.THREE_YEAR_COMMIT.endDates = generateLoyalty3YCEndDates(
              endDate
            );
          }
        };
      }
    )
    .service(
      'MiniJil',
      /* @ngInject */
      function(_, $http, $q, MiniJilStore, Utility) {
        /*=== Decorate $q's deferred ===*/
        //Decorate the deferred object returned by calling $q.defer() for the following reasons:
        // - implement `success` and `error` on the promise object to match the promise object returned by the $http
        // - add `resolveLater` and `rejectLater` methods on the deferred object which resolve or reject the promise after a short delay
        //   to make it look more natural. Otherwise, calls which are resolved from the in-memory store return immediately.
        // - make the `xLater` methods cancellable
        var decoratedDeferred = function(deferred) {
          //Add the `success` and `error` methods to the promise object
          var decoratedPromise = function(promiseObj) {
            promiseObj.success = function(fn) {
              promiseObj.then(function(response) {
                fn(response.data, response.status, response.headers);
              });
              return promiseObj;
            };
            promiseObj.error = function(fn) {
              promiseObj.then(null, function(response) {
                fn(response.data, response.status, response.headers);
              });
              return promiseObj;
            };

            return promiseObj;
          };
          deferred.promise = decoratedPromise(deferred.promise);

          //Add the `resolveLater` and `rejectLater` methods to the deferred
          var timeout;
          var later = function(methodName, data, delay) {
            //Safe default for delay
            if (!_.isNumber(delay) || window.isNaN(delay) || !Number.isFinite(delay)) {
              delay = Utility.getRandomNumber(0.5, 1, 1) * 1000; //milliseconds*1000
            }

            timeout = setTimeout(function() {
              deferred[methodName](data);
            }, delay);
          };
          deferred.resolveLater = function(data, delay) {
            later('resolve', data, delay);
          };
          deferred.rejectLater = function(data, delay) {
            later('reject', data, delay);
          };

          //`cancel` is required because the xLater methods will serve data based on when their timeout expires
          //rather then in the sequence that data was requested, much like AJAX calls.
          deferred.cancel = function(data) {
            clearTimeout(timeout);
            //Status 0 to mimic AJAX cancel status
            deferred.reject(formatAsHttpResponse(data, 0));
          };

          return deferred;
        };

        /*=== Helpers ===*/
        //Returns a clone of the passed-in object
        //Used this method of cloning because it mimics what $http and its request transformers do
        //this being it's main purpose: to clone the object returned by formatAsHttpResponse() function.
        var clone = function(obj) {
          var string = JSON.stringify(obj);
          if (!string) {
            return null;
          }
          return JSON.parse(string);
        };

        //Wraps passed in object as an HTTP response object
        //The third argument, transformer, is used to transform data and
        //accepts anything Angular's $http service transformRequest would.
        var formatAsHttpResponse = function(data, status, transformer) {
          if (!status && status !== 0) {
            status = 200;
          }

          //Return a clone of the `data` object.
          //Returning the same data object (by reference) would wreak havoc.
          var outputData = clone(data);

          //Run the cloned data through the transformer if passed in.
          //When cloning the object, custom classes are lots becoming plain
          //objects. Thus, they no longer have a prototype.
          //Any methods defined on them, would be undefined and would throw an error.
          if (transformer) {
            outputData = transformer(outputData);
          }

          return {
            data: outputData,
            status: status
          };
        };

        /*=== Initialize Mini JIL ===*/
        this.initialize = function(useMockData) {
          var deferred = decoratedDeferred($q.defer());

          var jsonFile = useMockData ? 'mockData.json' : 'demoData.json';
          $http({method: 'GET', url: '/demo-data/offers.json'})
            .then(function(response) {
              MiniJilStore.offersBySegment = response.data;
            })
            .catch(function() {
              MiniJilStore.offersBySegment = {};
            });

          $http({
            method: 'GET',
            url: '/demo-data/' + jsonFile
          })
            .then(function(response) {
              //Save data in MiniJilStore
              try {
                MiniJilStore.demoUser = response.data.authorization;
                MiniJilStore.teamMembers = response.data.teamMembers;
                MiniJilStore.customerSegmentsMeta = response.data.customerSegments.meta;
                MiniJilStore.customerSegmentsPagination = response.data.customerSegments.pagination;
                MiniJilStore.customerSegments = response.data.customerSegments.segments;
                MiniJilStore.customers = response.data.customers;
                MiniJilStore.offers = response.data.offers;
                MiniJilStore.products = response.data.products;
                MiniJilStore.consumables = response.data.consumables;
                MiniJilStore.usage = response.data.usage;

                //No need to send the data to listeners, they only care about init being finished
                deferred.resolve(null);
              } catch (error) {
                //Something went wrong parsing data
                //Reject as 500 - Internal Server Error
                deferred.reject(formatAsHttpResponse(error, 500));
              }
            })
            .catch(function(response) {
              deferred.reject(formatAsHttpResponse(response.data, response.status));
            });

          return deferred.promise;
        };

        /*=== Demo User Profile ===*/
        this.getDemoUser = function() {
          var deferred = decoratedDeferred($q.defer());

          if (MiniJilStore.demoUser) {
            deferred.resolve(MiniJilStore.demoUser);
          } else {
            deferred.reject(formatAsHttpResponse(null, 404));
          }

          return deferred.promise;
        };

        /*=== Team Members ===*/
        //Get team members, optionally filtering out inactive ones
        this.getTeamMembers = function(onlyActive) {
          if (MiniJilStore.teamMembers) {
            if (onlyActive) {
              return MiniJilStore.activeTeamMembers;
            } else {
              return MiniJilStore.teamMembers;
            }
          }

          return null;
        };

        //Invite new team member
        this.inviteTeamMember = function(emails) {
          if (emails.length) {
            var created = [];
            _.forEach(emails, function(email) {
              var newTeamMember = MiniJilStore.addTeamMember(email);
              created.push(newTeamMember);
            });

            return {
              created: created,
              duplicate: null,
              failed: null
            };
          }

          return null;
        };

        //Remove RTM
        this.removeTeamMember = function(teamMemberId) {
          return MiniJilStore.removeTeamMember(teamMemberId);
        };
        //Cancel RTM invitation
        this.cancelTeamMemberInvitation = function(invitationCode) {
          return MiniJilStore.cancelTeamMemberInvitation(invitationCode);
        };

        /*=== Customer Segments ===*/
        this.getCustomers = function(requestedSegment, payload) {
          var response = MiniJilStore.getCustomers(requestedSegment, payload);
          if (response.customers && response.customers.length) {
            return response;
          }

          return null;
        };

        /*=== Customer Details ===*/
        this.getCustomer = function(customerId) {
          return MiniJilStore.customers[customerId];
        };

        /*=== Customer Renewal Quote ===*/
        this.getCustomerQuote = function(customerId) {
          if (
            MiniJilStore.customers[customerId] &&
            MiniJilStore.customers[customerId].renewalQuote
          ) {
            return MiniJilStore.customers[customerId].renewalQuote;
          }

          return null;
        };

        /*=== Get Customer Loyalty 3YC Dates ===*/
        this.getCustomerLoyalty3yc = function(customerId) {
          return MiniJilStore.get3YCLoyaltyInfo(customerId);
        };

        /*=== Update Customer Loyalty 3YC Dates ===*/
        this.updateCustomerLoyalty3yc = function(customerId, payload) {
          MiniJilStore.update3YCLoyaltyInfo(customerId, payload.endDate);

          return true;
        };

        /*=== Invite Customer ===*/
        this.inviteCustomer = function(customer) {
          return MiniJilStore.inviteCustomer(customer);
        };

        /*=== Cancel Invitation ===*/
        this.cancelInvitation = function(customerID) {
          MiniJilStore.cancelCustomerInvitation(customerID);
          return true;
        };

        /*=== Update Invitation ===*/
        this.updateInvitation = function(customerID, payload) {
          return MiniJilStore.updateCustomerInvitation(customerID, payload);
        };

        /*=== Create Purchase Authorization ===*/
        this.createPurchaseAuthorization = function(customerId, purchaseDetails) {
          MiniJilStore.newPurchaseAuthorization(customerId, purchaseDetails);
          return true;
        };

        /*=== Update Customer ===*/
        this.updateCustomer = function(customerId, payload) {
          return MiniJilStore.updateCustomer(customerId, payload);
        };

        /*=== Cancel Purchase Authorization ===*/
        this.cancelPurchaseAuthorization = function(customerId, purchaseId) {
          MiniJilStore.removePurchaseAuthorization(customerId, purchaseId);
          return true;
        };

        /*=== Get Offers ===*/
        this.getOffers = function(customerId) {
          var segment = _.get(MiniJilStore, 'customers[' + customerId + '].details.marketSegment');
          var offers = _.get(MiniJilStore, 'offersBySegment.marketSegments[' + segment + ']');
          return offers;
        };

        /*=== Get Products ===*/
        this.getProducts = function(customerId) {
          var deferred = decoratedDeferred($q.defer());
          var products = _.get(MiniJilStore, `products[${customerId}]`, []);
          if (products) {
            deferred.resolveLater(products);
          } else {
            deferred.rejectLater(formatAsHttpResponse(null, 404));
          }
          return deferred.promise;
        };

        /*=== Get Consumable List ===*/
        this.getConsumableList = function(customerId) {
          var deferred = decoratedDeferred($q.defer());
          var consumables = _.get(MiniJilStore, `consumables[${customerId}]`, []);
          if (consumables) {
            deferred.resolveLater(consumables);
          } else {
            deferred.rejectLater(formatAsHttpResponse(null, 404));
          }
          return deferred.promise;
        };

        /*=== Get Usage List ===*/
        this.getUsageList = function(params, pagination) {
          var deferred = decoratedDeferred($q.defer());
          var usages = _.get(
            MiniJilStore,
            `usage[${params.organizationId}][${params.fulfillableItemCode}]`,
            []
          );
          if (usages) {
            let requestedUsages = usages;
            if (usages.length > pagination.pageSize) {
              const paginatedArray = _.chunk(usages, pagination.pageSize);
              requestedUsages = paginatedArray[pagination.currentPage - 1];
            }
            deferred.resolveLater(requestedUsages);
          } else {
            deferred.rejectLater(formatAsHttpResponse(null, 404));
          }
          return deferred.promise;
        };

        /*=== Cart Save / Create PA ===*/
        // Even though the cart is not a JIL call, we'll use MiniJil to mock it, since we'll need to update its data.
        this.mockCartSave = function(customerId, payload) {
          // Create the PA for mocking
          MiniJilStore.newPurchaseAuthorization(customerId, payload);

          //Return the promise
          var deferred = decoratedDeferred($q.defer());
          deferred.resolveLater(null);
          return deferred.promise;
        };

        /*=== Cart Cancel / Cancel PA ===*/
        // Even though the cart is not a JIL call, we'll use MiniJil to mock it, since we'll need to update its data.
        this.mockCartCancelPA = function(customerId, payload) {
          var purchaseId =
            payload.billing_summary.billable_items[0].entitlement_details.purchase_auth_id;
          // Cancel the PA
          MiniJilStore.removePurchaseAuthorization(customerId, purchaseId);

          //Return the promise
          var deferred = decoratedDeferred($q.defer());
          deferred.resolveLater(null);
          return deferred.promise;
        };
      }
    );
})();
